// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg[data-v-3ef93950]{fill:currentColor}[data-v-3ef93950] .fa-kit{font-family:Font Awesome Kit!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
